var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocketOutlet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.04,
    y: 2.76,
    className: "st2",
    width: 0.5,
    height: 10.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.46,11.95l-0.04-0.5c1.92-0.15,3.35-1.77,3.26-3.7C4.52,5.99,3.07,4.61,1.3,4.54l0.02-0.5 C3.34,4.12,4.99,5.7,5.17,7.72C5.28,9.92,3.65,11.78,1.46,11.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.92,
    y: 7.75,
    className: "st2",
    width: 1.95,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.43,11.57c-1.94,0-3.52-1.58-3.52-3.52s1.58-3.52,3.52-3.52s3.52,1.58,3.52,3.52S13.38,11.57,11.43,11.57z  M11.43,5.03c-1.67,0-3.02,1.36-3.02,3.02s1.36,3.02,3.02,3.02s3.02-1.36,3.02-3.02S13.1,5.03,11.43,5.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.37,7.07c0-1.26-1.46-2.29-2.95-2.29S8.48,5.72,8.48,6.99L14.37,7.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.5,7.19l-0.13,0L8.36,7.12V6.99c0-1.4,1.59-2.34,3.07-2.34c1.64,0,3.08,1.13,3.08,2.41V7.19z M8.61,6.87 l5.63,0.07c-0.09-1.08-1.4-2.04-2.82-2.04C10.11,4.9,8.7,5.69,8.61,6.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9.99,
    cy: 8.24,
    r: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.99,8.95c-0.39,0-0.71-0.32-0.71-0.71S9.6,7.53,9.99,7.53s0.71,0.32,0.71,0.71S10.38,8.95,9.99,8.95z  M9.99,7.78c-0.25,0-0.46,0.2-0.46,0.46S9.73,8.7,9.99,8.7s0.46-0.2,0.46-0.46S10.24,7.78,9.99,7.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.15,
    y: 7.79,
    className: "st2",
    width: 1.04,
    height: 1.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.31,8.96h-1.29V7.66h1.29V8.96z M12.27,8.71h0.79V7.91h-0.79V8.71z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketOutlet);
export default __webpack_public_path__ + "static/media/SocketOutlet.7bdd4febc2c65a117f818d771572dce0.svg";
export { ForwardRef as ReactComponent };